import ArtifactGroupType from "../base/ArtifactGroupType";


const MayaCodexOfMexico = {
  id: '150',
  name: "Maya Codex of Mexico",
  groupIcon: 'UnderTheCeiba',
  type: ArtifactGroupType.UNDER_THE_CEIBA,
  icon: 'MayaCodexOfMexico',
  power: 50
};

export default MayaCodexOfMexico;
